import Helmet from 'react-helmet';
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, DropdownButton, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router';

import { DatePicker } from './components/DatePicker';
import Filter from './components/ReportFilter';
import NoData from '../../components/NoData/NoData';
import Loading from '../../components/Loading/Loading';
import Header from '../../components/Header/Header';
import Confirm from '../../components/Confirm/Confirm';

import { 
  getFilters, 
  setFilters, 
  requestData, 
  requestComparisonData, 
  getPdf, 
  getComparisonPdf,
  getCsv,
  selectStream,
  deleteStream,
  listAll,
  saveSelected,
  saveSelectedBreakdown,
  saveSelectedDateRange 
} from './ReportActions';
import Views from './components/ExecDashboardView/Views';
import ReportTable from './components/ReportTable/ReportTable';
import SaveView from './components/ExecDashboardView/SaveView';
import LineChart from './components/LineChart';
import ValueStreamSelector from './components/ValueStreamSelector';
import SubscribeEDAddOn from '../../components/SubscribeEDAddOn/SubscribeEDAddOn';

import exportIcon from '../../assets/img/download.svg';
import cloudDownload from '../../assets/images/cloud-download-icon.svg';
import settingsIcon from '../../assets/img/settings-icon.svg';
import createIcon from '../../assets/img/createDashboard-icon.svg';
import lineChartOnIcon from '../../assets/img/line-chart-icon-on.svg';
import lineChartOffIcon from '../../assets/img/line-chart-icon-off.svg';


import dashboardIcon from '../../assets/img/dashboard.svg';
import deleteIcon from '../../assets/img/delete.svg';
import editIcon from '../../assets/images/edit-blue.svg';
import defaultBoardImg from '../../assets/images/stream-default-icon.jpg'; 

import expandIcon from '../../assets/img/zoom-icon-off.svg';
import collapseIcon from '../../assets/img/zoom-icon-on.svg';

import momentDurationFormatSetup from '../../util/moment-duration';

import { PieChartWidget } from './components/PieChartWidget';

import { 
  trackExecutiveFilterChange, 
  trackReportConfigChange, 
  trackExecutiveDashboardView } from '../../util/mixpanel';

import './Reports.scss';
import _ from 'lodash';

function formatCycletimeLabel(point, timePrecision) {
  const duration = moment.duration(point.y, 'minutes').format(timePrecision, { trim: 'mid both' });
  return `(${duration}) ${(point.percentage || 0).toFixed(2)}%`;
}

function formatThroughputLabel(point) {
  return `${(point.percentage || 0).toFixed(2)}% (${point.y} ${point.y > 1 ? 'items' : 'item'})`;
}

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comparison: false,
      percentile: (props.filters && props.filters.percentile) || 85,
      threshold: (props.filters && props.filters.threshold) || 5,
      dateRange: props.dateRange || 'lastMonth',
      dateFormat: (props.filters && props.filters.dateFormat) || 'D/MM/YY',
      isFullScreen: '',
      cycletime: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      throughput: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      wip: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      wat: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      page: 1,
      th: false,
      wp: false,
      wat: false,
      ct: false,
      fe: false
    };
  }

  componentDidMount() {
    const isComparisonInitially = this.props.location.search && this.props.location.search.includes('comparison=true');
    const currentReportId = this.props.routeParams.id || this.props.selectedStream && this.props.selectedStream._id;

    this.setState({ comparison: isComparisonInitially });

    if (!this.trialExpired()) {
      if (isComparisonInitially) {
        if (currentReportId) {
          this.props.getFilters(currentReportId);
        }        
      } else {
        if (currentReportId) {
          this.props.getFilters(currentReportId);
        } 
      }
    } 
  }

componentDidUpdate(prevProps, prevState) {
  const prevStreamId = prevProps.selectedStream ? prevProps.selectedStream._id : undefined;
  const currentStreamId = this.props.selectedStream ? this.props.selectedStream._id : undefined;
  const currentReportContextId = this.props.routeParams.id || currentStreamId;
  const prevReportContextId = prevProps.routeParams.id || prevStreamId;
  const reportContextIdChanged = currentReportContextId !== prevReportContextId;

    const filtersChanged = !_.isEqual(prevProps.filters, this.props.filters);
    const locationSearchChanged = prevProps.location.search !== this.props.location.search;

    if (this.props.routeParams.id && !this.props.loading && _.findIndex(this.props.streams, { _id: this.props.routeParams.id }) === -1){      
      this.props.router.push('/no-value-stream-permissions');
    }
    if (reportContextIdChanged && currentReportContextId) {
      this.props.getFilters(currentReportContextId);      
    }

    if (locationSearchChanged) {
      const newIsComparisonFromUrl = this.props.location.search && this.props.location.search.includes('comparison=true');
      if (newIsComparisonFromUrl !== this.state.comparison) {
        this.setState({ comparison: newIsComparisonFromUrl }, () => {
          if (this.state.comparison) {
            this.getComparsion(currentStreamId);
          } else {
            if (currentReportContextId) this.props.requestData(currentReportContextId);
            this._syncBreakdownSettingsFromProps(this.props, prevProps);
          }
        });
      }
    }   

  if (filtersChanged && this.props.filters && this.props.filters.name && !this.props.loading) {
    if (!this.state.comparison) {
      const loaded = this._syncBreakdownSettingsFromProps(this.props, prevProps);
      if (currentReportContextId && !loaded) this.props.requestData(currentReportContextId);
    } else {
      // Refresh comparison data when filters change in comparison mode
      this.getComparsion(currentStreamId);
    }
    }
    else if (reportContextIdChanged && this.props.filters && this.props.filters.name && !this.state.comparison) {
      this._syncBreakdownSettingsFromProps(this.props, prevProps);
    }
  }

  getBreakDownName(values) {
    const { filters } = this.props;
    let name;

    if (values.indexOf('labels') > -1) {
      switch (this.props.app) {
        case 'azure':
          return 'Work item types';
        case 'trello':
          return 'Labels';
        case 'asana':
          return 'Tags';
        case 'jira':
          return 'Priorities';
      }
    }

    if (values.indexOf('statuses') > -1) {
      switch (this.props.app) {
        case 'jira':
        case 'file': 
          return 'Statuses';
        case 'azure':
          return 'Columns';
        case 'trello':
          return 'Lists';
        case 'asana':
          return 'Sections';
      }
    }

    _.some(values, value => {
      return _.some(filters.dashboards, dashboard => {
        const cf = _.find(dashboard.allCustomFields, { id: value });
        if (cf) {
          name = cf.name;
          return true;
        }
      });
    });
    return name;
  };


  updateFontSize = chart => {};

 getReport = (newDashboardFilters = this.props.filters.dashboards, triggerDataRefresh = true, updateFilters = false) => {
    const { threshold, percentile } = this.state;
    const { wallmode, selectedStream, routeParams, setFilters, requestData } = this.props;
    const currentReportId = selectedStream && selectedStream._id || routeParams.id;

    if (!currentReportId) {
      return;
    }

    const bodyForSetFilters = {
      dashboards: newDashboardFilters,     
      controls: { threshold, percentile }
    };

    if (!wallmode && selectedStream && updateFilters) {
      setFilters(currentReportId, bodyForSetFilters);
    }

    if (triggerDataRefresh && !this.state.comparison) {
      requestData(currentReportId);
    }
  };

  applyFilters = (filters = {}, isInitial) => {
    this.getReport(filters, isInitial, true);

    if(!isInitial){
      trackExecutiveFilterChange(this.getDashboardsNames(), 'filters');
    }
  }

  handleDateChange = dates => {
    const body = {
      dates: {
        startDate: dates.startDate.toISOString(),
        endDate: dates.endDate.toISOString(),
        customDate: dates.customDate,
        fixedStartDate: dates.fixedStartDate,
        dateDiff: dates.daysFromStart
      }
    };

    this.props.setFilters(this.props.selected._id, body);

    trackExecutiveFilterChange(this.getDashboardsNames(), 'period', body.dates);
  };

  handleConfigure = () => {
    this.props.router.push('/configure/'+  this.props.selected._id);
  };

  handleNew = () => {
    this.props.select({ isNew: true});
    this.props.router.push('/configure');
  };

  handlePdfExport = () => {
    if (this.state.comparison) {
      const { percentile, threshold } = this.state;
      this.props.getComparisonPdf(percentile, threshold, this.props.selected && this.props.selected._id);
      return;
    }
    this.props.getPdf(this.props.selected && this.props.selected._id);
  };

  handleCsvExport = () => {
    this.props.getCsv(this.props.selected && this.props.selected._id);
  }

  getComparsion = (currentStreamId) => {
    const { page } = this.state;
    this.props.requestComparisonData(page, currentStreamId);
  };

  changePercentile = value => {
    this.setState({ percentile: parseInt(value, 10) });

    trackReportConfigChange(this.getDashboardsNames(), 'ct_percentile', { percent: parseInt(value, 10) } );
  };

  changeThreshold = value => {
    this.setState({ threshold: value });

    trackReportConfigChange(this.getDashboardsNames(),'controls', { variation: value } );
  };

  changeDateRange = value => {
    this.setState({ dateRange: value });
    this.props.saveSelectedDateRange(this.props.selected._id, value);

    trackReportConfigChange(this.getDashboardsNames(), 'controls', { group_by: this.getGroupByValue(value) } );
  };

  getGroupByValue(value) {
    switch(value) {
      case 'lastWeek':
        return 'one_week';
      case 'last2Week':
        return 'two_weeks';
      case 'lastMonth':
        return 'month';
      case 'last3Month':
        return 'quarter';
      default:
        return value;
    }
  }

  getDashboardsNames() {
    return this.props.filters && this.props.filters.dashboards ? 
      _.join(_.map(this.props.filters.dashboards, 'name')) : '';
  }

  toggleView = (comparison) => {
    if (!this.props.loading && (comparison !== this.state.comparison)){
      this.setState({ comparison });
      if (comparison) {
        this.getComparsion(this.props.routeParams.id);
      } else {
        this.props.requestData(this.props.routeParams.id);
      }      
    }
  };

  compare(current, previous) {
    return Math.round((10000 * current) / previous) / 100 - 100;
  }

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getComparsion);
  };

  onBreakdownChange = (widget, field) => {
    const { selectedStream, saveSelectedBreakdown, wallmode } = this.props;
    const reportId = selectedStream && selectedStream._id;
    if (!reportId) {
      return;
    }
    if (!wallmode){
      saveSelectedBreakdown(reportId, widget, field.id);
    }    
    trackExecutiveFilterChange(this.getDashboardsNames(), `${widget}_breakdown_by`, {
      breakdown_by: field.id === null ? '' : field.name
    });
  }

  handleResize = ev => {
    const chart = ev.target.id.split('-')[1];
    if (this.state.isFullScreen) {
      this.setState(
        { isFullScreen: '' },
        () => this.updateFontSize(chart)
      );
    } else {
      this.setState(
        { isFullScreen: chart },
        () => this.updateFontSize(chart)
      );

      trackExecutiveDashboardView(chart);
    }
  };

  trackChartDetailsView (chart, isHidden) {
    if (!isHidden) {
      trackExecutiveDashboardView(chart + '_details');
    }
  }

  fillComparisonValues = (getValue, threshold) => {
    const currentMonthValue = getValue(0);
    const values = [];
    values.push({ value: currentMonthValue });
    for (let j = 1; j < 4; j++) {
      if (currentMonthValue) {
        const cValue = getValue(j);
        const cComparison = this.compare(currentMonthValue, cValue);
        values.push({
          value: cValue,
          comparison: cComparison,
          active: Math.abs(cComparison) > threshold
        });
      } else {
        values.push({});
      }
    }
    return values;
  };

  convertReportDataItemToComparisonValues = (percentile, threshold, d, dashboard) => {
    const item = {
      name: dashboard.name,
      month: d.month,
      avgCycleTime: this.fillComparisonValues(
        i => _.find(d.comparison[i].cycleTime, { name: percentile }).value,
        threshold
      ),
      avgThroughput: this.fillComparisonValues(i => d.comparison[i].throughput, threshold),
      wipTrend: this.fillComparisonValues(i => d.comparison[i].wipTrend, threshold),
      wipAge: this.fillComparisonValues(i => d.comparison[i].wipAge, threshold),
      flowEfficiency: this.fillComparisonValues(i => d.comparison[i].flowEfficiency, threshold)
    };

    return item;
  };
_deriveBreakdownStateForWidget(widgetType, currentProps = this.props) {
    const { filters } = currentProps;
    const breakdownList = this.getBreakDownList(widgetType);

    let defaultName = '';
    let defaultValue = [];

    if (breakdownList && breakdownList.length > 0) {
      defaultName = breakdownList[0].name;
      defaultValue = breakdownList[0].id;
    } else {
      return {
        ...this.state[widgetType],
        name: '', search: '', value: [],
      };
    }

    const selectedBreakdownIdsFromFilters = filters && filters[widgetType];
    let derivedName = defaultName;
    let derivedValue = defaultValue;
    let shouldSetDefault = true;

    if (selectedBreakdownIdsFromFilters && Array.isArray(selectedBreakdownIdsFromFilters) && selectedBreakdownIdsFromFilters.length > 0) {
      const nameFromFilterIds = this.getBreakDownName(selectedBreakdownIdsFromFilters);
      if (nameFromFilterIds) {
        const foundInList = breakdownList.find(item => item.name === nameFromFilterIds);
        if (foundInList) {
          derivedName = foundInList.name;
          derivedValue = foundInList.id;
          shouldSetDefault = false;
        }
      }
    }

    // If no valid breakdown is selected and we have options, set the default
    if (shouldSetDefault && breakdownList.length > 0 && filters && filters.name) {
      const { selectedStream, routeParams } = currentProps;
      const reportId = selectedStream && selectedStream._id || routeParams.id;
      if (reportId && this.props.saveSelectedBreakdown) {
        // Save the default breakdown selection
        setTimeout(() => {
          this.props.saveSelectedBreakdown(reportId, widgetType, defaultValue);
        }, 0);
      }
    }

    return {
      ...this.state[widgetType],
      name: derivedName,
      search: derivedName,
      value: derivedValue,
    };
  }

 _syncBreakdownSettingsFromProps(propsToUse = this.props, prevProps = {}) {
    const { filters, selectedStream, routeParams, stats } = propsToUse;
    const currentReportId = selectedStream && selectedStream._id || routeParams.id;

    if (!filters || !filters.name || !currentReportId) {
        return;
    }

    const newCycleTimeState = this._deriveBreakdownStateForWidget('cycletime', propsToUse);
    const newThroughputState = this._deriveBreakdownStateForWidget('throughput', propsToUse);

    const stateToUpdate = {};
    let needsUiUpdateForBreakdownSelection = false;

    if (!_.isEqual(this.state.cycletime.name, newCycleTimeState.name) || !_.isEqual(this.state.cycletime.value, newCycleTimeState.value)) {
      stateToUpdate.cycletime = { ...this.state.cycletime, ...newCycleTimeState };
      needsUiUpdateForBreakdownSelection = true;
    }
    if (!_.isEqual(this.state.throughput.name, newThroughputState.name) || !_.isEqual(this.state.throughput.value, newThroughputState.value)) {
      stateToUpdate.throughput = { ...this.state.throughput, ...newThroughputState };
      needsUiUpdateForBreakdownSelection = true;
    }

    let criticalFiltersChanged = false;
    if (prevProps.filters) {
        const relevantCurrentFilters = {
            dashboards: filters.dashboards,
            controls: filters.controls,
            name: filters.name
        };
        const relevantPrevFilters = {
            dashboards: prevProps.filters.dashboards,
            controls: prevProps.filters.controls,
            name: prevProps.filters.name
        };
        function preprocessFilters(filters) {
          const clonedFilters = _.cloneDeep(filters); // Use Lodash's cloneDeep
          if (clonedFilters.dashboards && Array.isArray(clonedFilters.dashboards)) {
            clonedFilters.dashboards.forEach(dashboard => {
              if (dashboard.allMembers && Array.isArray(dashboard.allMembers)) {
                dashboard.allMembers.forEach(member => {
                  if (member && member._id === 'no-member' && member.value === 'no-member') {
                    delete member.label;
                  }
                });
              }
            });
          }
          return clonedFilters;
        }

        const processedCurrentFilters = preprocessFilters(relevantCurrentFilters);
        const processedPrevFilters = preprocessFilters(relevantPrevFilters);
        if (!_.isEqual(processedCurrentFilters, processedPrevFilters)) {
            criticalFiltersChanged = true;
        }
    } else {
        criticalFiltersChanged = true;
    }

    if (needsUiUpdateForBreakdownSelection) {
      this.setState(stateToUpdate, () => {
        if (!this.state.comparison) {
          this.getReport(filters.dashboards, true);
        }
      });
    } else if (!this.state.comparison && criticalFiltersChanged) {
      this.getReport(filters.dashboards, true);
    }
}

deleteStream() {
  this.props.remove(this.props.selected._id);
  if (this.state.comparison) {
    this.props.router.push('/report?comparison=true');
  } else {
    this.props.router.push('/report');
  }
}

  renderComparisonReport() {
    const { percentile, threshold, dateRange } = this.state;
    const { comparisons, wallmode } = this.props;
    const comparison = comparisons && comparisons[dateRange] && comparisons[dateRange].data;
    const comparisonDates = comparisons && comparisons[dateRange] && comparisons[dateRange].dates;
    let result = [];
    _.forEach(comparison, dashboard => {
      _.forEach(dashboard.data, (d, i) => {
        let item = this.convertReportDataItemToComparisonValues(percentile, threshold, d, dashboard);
        result.push(item);
      });
    });

    result = _.groupBy(result, 'month');
    return [
      <div className='report execdashboard comparison'>
        <NoData show={!result && !this.props.loading} />
        {this.props.loading && (
          <div className='table-loading'>
            <Loading />
          </div>
        )}
        {!wallmode && (<div className='button_tools tracking'>
          <Link className="btn btn-secondary btn-md" to={`/report/${this.props.selected._id}`}>
            Value Stream Dashboard
          </Link>
        </div>)}
        {result && comparisonDates && (
          <React.Fragment>
            <ReportTable
              key="avgCycleTimeReportTable"
              percentile={this.state.percentile}
              changePercentile={this.changePercentile}
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Cycle Time"
              fieldName="avgCycleTime"
              positive={true}
              time={true}
            ></ReportTable>
            <ReportTable
              key="avgThroughputReportTable"
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Average Throughput"
              fieldName="avgThroughput"
              positive={false}
            ></ReportTable>
            <ReportTable
              key="wipTrendReportTable"
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Average WIP"
              fieldName="wipTrend"
              positive={true}
            ></ReportTable>
            <ReportTable
              key="awipAgeReportTable"
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Average WIP Age"
              fieldName="wipAge"
              positive={true}              
              time={true}
            ></ReportTable>
            <ReportTable
              key="flowEfficiencyReportTable"
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Flow Efficiency"
              fieldName="flowEfficiency"
              positive={false}
            ></ReportTable>
          </React.Fragment>
        )}
      </div>
    ];
  }

  renderPercentiles() {
    return (
      <div className='report-info-box'>
        {this.props.stats.avgPercentiles &&
          this.props.stats.avgPercentiles.map((p, i) => {
            return (
              <div key={i}>
                <h4>
                  {moment.duration(p.value, 'minutes').format('d[d] h[h] m[m]', { trim: 'mid both' })}
                </h4>
                <p>{p.text}th percentile</p>
              </div>
            );
          })}
      </div>
    );
  }
renderButtons() {
  return [
    <SubscribeEDAddOn key="subscribe" />,
    <DropdownButton
      key="1"
      id="createportfolio-dropdown"
      variant='secondary'
      size='sm'
      title={
        <OverlayTrigger placement="bottom"
          overlay={<Tooltip id="tooltip-createportfolio" className='tooltip_dark'>Create Value Stream</Tooltip>}>
            <img src={createIcon} alt="" />
        </OverlayTrigger>
        }
      >
      <li>
        <Link key="1" onClick={this.handleNew} className='btn'>
          <span className="title"><img src={createIcon} alt="#"/> Create Value Stream</span>
          <span className="help-text">
            Select the team dashboards you’d like to include to build a value stream and visualize your end-to-end delivery flow.
          </span>                        
        </Link>
      </li>             
    </DropdownButton>,      
    
    this.props.selected && (
      <DropdownButton
        disabled = {this.props.loading}
        key="settings-dropdown"
        id="dashboards-dropdown"
        size='sm'
        variant='secondary'
        title={
          <OverlayTrigger 
            placement="bottom" 
            overlay={
              <Tooltip id="tooltip-settings" className='tooltip_dark'>
                Value Stream Settings
              </Tooltip>
            }
          >
            <img src={settingsIcon} alt="" />
          </OverlayTrigger>
        }
      >
        {this.state.comparison ? (
          <li key="pdf-export">
            <Button onClick={this.handlePdfExport}>
              <span className="title">
                  <img src={exportIcon} alt="Export"/> Export PDF Report
              </span> 
              <span className="help-text">
                Generate a PDF report of your dashboard for easy sharing and presentation.
              </span>
            </Button>
          </li>
        ) : (
          <React.Fragment>
            <li key="csv-export">
              <Button onClick={this.handleCsvExport}>
                <span className="title">
                  <img src={cloudDownload} alt="Export"/> Export Dashboard Data
                </span>               
                <span className="help-text">
                  Export your dashboard data as a CSV file to create custom reports.
                </span>
              </Button>
            </li>
            <li key="pdf-export">
              <Button onClick={this.handlePdfExport}>
                <span className="title">
                  <img src={exportIcon} alt="Export"/> Export PDF Report
                </span> 
                <span className="help-text">
                  Generate a PDF report of your dashboard for easy sharing and presentation.
                </span>
              </Button>
            </li>
          </React.Fragment>
        )}

        <li key="edit-stream" onClick={ev => this.handleConfigure(this.props.selected)}>
          <div className='btn'>
            <span className="title">
              <img src={editIcon} alt="Edit" /> Edit Value Stream
            </span>
            <span className="help-text">
              Add or remove dashboards connected to this value stream and update your data.
            </span>
          </div>
        </li>

        <li key="delete-stream">
          <Confirm 
            onConfirm={ev => this.deleteStream()}
            body={
              <p>
                Are you sure you want to delete <strong>{this.props.selected.name}</strong>?
              </p>
            }
            confirmText="Delete"
            icon={deleteIcon}
            title="Delete value stream"
          >
            <div className='btn'>
              <span className="title red">
                <img src={deleteIcon} alt="Delete" /> Delete Value Stream
              </span>
              <span className="help-text">
                Permanently delete the value stream and all associated dashboard data. 
                This action cannot be undone.
              </span>
            </div>
          </Confirm>
        </li>
      </DropdownButton>
    ),

    <DropdownButton
      disabled = {this.props.loading}
      key="dashboard-actions"
      id="createdashboards-dropdown"
      size='sm'
      variant='secondary'
      title={<img src={dashboardIcon} alt="Dashboard actions" />}
    >
      <li key="apply-view">
        <Views>
          <Button>
            Apply dashboard view
            <span className="help-text">
              Apply the set of controls and filters previously stored on this dashboard
            </span>
          </Button>
        </Views>
      </li>
      <li key="save-view">
        <SaveView>
          <Button>
            Save current dashboard view
            <span className="help-text">
              Store the current set of controls and filters on this dashboard
            </span>
          </Button>
        </SaveView>
      </li>
    </DropdownButton>
  ];
}

  getBreakDownList(chart) {
    const { filters } = this.props;
    const isCycletime = chart === 'cycletime';
    if (filters) {
      const list = _(filters.dashboards)
        .map(d => d.allCustomFields)
        .flatten()
        .groupBy('name')
        .map((value, key) => ({ name: key, id: _.map(value, v => v.id) }))
        .value();

      if (this.props.app === 'file') {
        const flags = { azure: false, jira: false };
        _.forEach(filters.dashboards, d => {
          if (!d.isCsv && d.isAzure) flags.azure = true;
          if (!d.isCsv && !d.isAzure) flags.jira = true;
        });
        if (flags.azure) {
          list.push({ name: 'Work item types', id: ['labels'] });
        }
        if (flags.jira) {
          list.push({ name: 'Priorities', id: ['labels'] });
        }
      }

      switch (this.props.app) {
        case 'azure':
          list.push({ name: 'Work item types', id: ['labels'] });
          isCycletime && list.push({ name: 'Columns', id: ['statuses'] });
          break;
        case 'asana':
          list.push({ name: 'Tags', id: ['labels'] });
          isCycletime && list.push({ name: 'Sections', id: ['statuses'] });
          break;
        case 'jira':
          list.push({ name: 'Priorities', id: ['labels'] });
          isCycletime && list.push({ name: 'Statuses', id: ['statuses'] });
          break;
        case 'trello':
          list.push({ name: 'Labels', id: ['labels'] });
          isCycletime && list.push({ name: 'Lists', id: ['statuses'] });
          break;
        case 'file': 
          isCycletime && list.push({ name: 'Statuses', id: ['statuses'] });
          break;
      }

      return _.orderBy(list, 'name');
    }
    return [];
  }

  renderExecutiveReport() {
    const flowEfficiency = !isNaN(this.props.stats.avgFe);
    const { wallmode } = this.props;

    const breakDownItemsCt = this.getBreakDownList('cycletime');
    const breakDownItemsTh = this.getBreakDownList('throughput');
    const subsetColors = _(this.props.trends && this.props.trends.throughput)
      .map(({ name, color }) => [name, color])
      .fromPairs()
      .value();


    const reportUrl = this.props.selected && this.props.selected._id ? `/report/${this.props.selected._id}?comparison=true` : '/report?comparison=true';
    return [
      <div className='report-wrap execdashboard'>
        {!wallmode && (<div className='button_tools tracking'>
          <Link className="btn btn-secondary btn-md" to={reportUrl}>
            Value Stream Report
          </Link>
          <DatePicker updateValue={wallmode ? null : this.handleDateChange} disableSave />
        </div>)}
        
        {this.props.loading && (
          <div className='table-loading'>
            <Loading />
          </div>
        )}


        {/*<NoData show={!this.props.trends.avgCt} />*/}

        <div className="row-cell-list">
          <PieChartWidget
            className="widget cell cell-33"
            name="cycletime-breakdown"
            title={
              <React.Fragment>
                Avg. Cycle Time <span>{moment.duration(this.props.stats.avgCt, 'minutes').format('d[d] h[h] m[m]', { trim: 'mid both' })}</span>
              </React.Fragment>
            }
            formatter={(p) => formatCycletimeLabel(p, this.props.filters.timePrecision)}
            breakdowns={this.props.stats.cycletimeBreakdowns}
            options={breakDownItemsCt}
            colors={subsetColors}
            selected={this.props.filters && this.props.filters.cycletime && this.props.filters.cycletime[0] || (breakDownItemsCt.length > 0 ? breakDownItemsCt[0].id[0] : '')}
            onResize={() => trackExecutiveDashboardView('cycletime-breakdown')}
            onSelect={(field) => this.onBreakdownChange('cycletime', field)}
          />
          
          <PieChartWidget
            className="widget cell cell-33"
            name="throughput-breakdown"
            title={
              <React.Fragment>
                Throughput <span>{this.props.stats.avgThroughput} work items</span>
              </React.Fragment>
            }
            formatter={(p) => formatThroughputLabel(p)}
            breakdowns={this.props.stats.throughputBreakdowns}
            options={breakDownItemsTh}
            colors={subsetColors}
            selected={this.props.filters && this.props.filters.throughput && this.props.filters.throughput[0] || (breakDownItemsTh.length > 0 ? breakDownItemsTh[0].id[0] : '')}
            onResize={() => trackExecutiveDashboardView('throughput-breakdown')}
            onSelect={(field) => this.onBreakdownChange('throughput', field)}
          />

          <div className='average cell-33'>
            {flowEfficiency && (
              <div className='cell cell-height-auto'>
                <div className='cell-header'>
                  <h4>Avg. Flow Efficiency <span>{this.props.stats.avgFe}%</span></h4>
                </div>
              </div>
            )}
            <div className='cell cell-height-full'>
              <div className='cell-header'>
                <h4>Avg. Cycle Time Percentiles</h4>
              </div>
              <div className="cell-content">
                {this.renderPercentiles()}
              </div>
            </div>
          </div>
        
          <div className={`cell ${ this.state.isFullScreen === 'wip' ? 'fullscreen' : '' } ${ this.state.wp ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>WIP Trends</h4>
              <Button variant="flat" size="md" onClick={() => {this.setState({ wp: !this.state.wp }); this.trackChartDetailsView('wip', this.state.wp)}}>
                <img src={this.state.wp ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button variant="flat" size="md" id="fullscreen-wip" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'wip' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
            
            <div className="cell-content">
              <LineChart
                id="wip"
                className="chart"
                detailed={this.state.wp}
                isFullScreen={this.state.isFullScreen === 'wip'}
                showExactDate={true}
                plural={false}
                tooltipLabel="Work items"
                unit="item"
                data={this.props.trends.wip}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'tht' ? 'fullscreen' : '' } ${ this.state.th ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>Throughput Trends</h4>
              <Button variant="flat" size="md" onClick={() => {this.setState({ th: !this.state.th }); this.trackChartDetailsView('tht', this.state.th)}}>
                <img src={this.state.th ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button variant="flat" size="md" id="fullscreen-tht" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'tht' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
            <div className='cell-content'>
              <LineChart
                id="throughput"
                className="chart"
                detailed={this.state.th}
                isFullScreen={this.state.isFullScreen === 'tht'}
                plural={true}
                tooltipLabel="Work items"
                unit="item"
                data={this.props.trends.throughput}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'wat' ? 'fullscreen' : '' } ${ this.state.wat ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>WIP Age Trends</h4>
              <Button variant="flat" size="md" onClick={() => {this.setState({ wat: !this.state.wat }); this.trackChartDetailsView('wat', this.state.wat)}}>
                <img src={this.state.wat ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button variant="flat" size="md" id="fullscreen-wat" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'wat' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
            <div className='cell-content'>
              <LineChart
                id="wat"
                className="chart"
                detailed={this.state.wat}
                showExactDate={true}
                isFullScreen={this.state.isFullScreen === 'wat'}
                tooltipLabel="Avg. WIP Age Time"
                unit="day"
                data={this.props.trends.avgWat}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'ctt' ? 'fullscreen' : ''} ${ this.state.ct ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>Cycle Time Trends</h4>
              <Button variant='flat' size="md" onClick={() => {this.setState({ ct: !this.state.ct }); this.trackChartDetailsView('ctt', this.state.ct)}}>
                <img src={this.state.ct ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button variant='flat' size="md" id="fullscreen-ctt" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'ctt' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
            <div className='cell-content'>
              <LineChart
                id="ct"
                className="chart"
                detailed={this.state.ct}
                isFullScreen={this.state.isFullScreen === 'ctt'}
                tooltipLabel="Avg. Cycle Time"
                unit="day"
                data={this.props.trends.avgCt}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'percentile' ? 'fullscreen' : '' }`}>
            <div className='cell-header'>
              <h4>Percentile Trends</h4>
              <Button variant='flat' size="md" id="fullscreen-percentile" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'percentile' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
            <div className='cell-content'>
              <LineChart
                id="percentiles-trend"
                className="chart"
                isFullScreen={this.state.isFullScreen === 'percentile'}
                tooltipLabel=""
                unit=""
                data={this.props.trends.percentiles}
              />
            </div>
          </div>
        
          <div className={`cell ${this.state.isFullScreen === 'fe' ? 'fullscreen' : ''} ${ this.state.fe ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>Flow Efficiency Trends</h4>
              <Button variant="flat" size="md" onClick={() => {this.setState({ fe: !this.state.fe }); this.trackChartDetailsView('fe', this.state.fe)}}>
                <img src={this.state.fe ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button variant="flat" size="md" id="fullscreen-fe" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'fe' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
            <div className='cell-content'>
              <LineChart
                id="fe"
                className="chart"
                detailed={this.state.fe}
                isFullScreen={this.state.isFullScreen === 'fe'}
                tooltipLabel="Avg. Flow Efficiency"
                unit="%"
                data={this.props.trends.flowEfficiency}
              />
            </div>
          </div>
        </div>
      </div>
    ];
  }

  trialExpired(){
    return !this.props.user.config || moment(this.props.user.config.exportTrialEnd).diff(moment()) < 0 || !this.props.user.config.exportEnabled;
  }

  render() {
    const { wallmode, filters, dateRange } = this.props;
    const trialExpired = this.trialExpired();
    return [      
      !trialExpired && <ValueStreamSelector key="1" title="" buttons={wallmode ? null : this.renderButtons()} showTeam={true} 
        items={this.props.streams}
        selectedItem={this.props.selectedStream}
        onSelect={this.props.selectStream}
        onSaveSelected={this.props.saveSelectedStream}
        onListAll={this.props.listAllStreams}
        loaded = {this.props.loaded}
        noItems={this.props.noStreams}
        basePath="/report"
        emptyPath="/no-streams"
        searchPlaceholder="Search Value Stream"
        defaultItemImage={defaultBoardImg} 
        defaultItemIdFromUserConfigKey="selectedValueStream" 
        dataIsLoading={this.props.loading} 
        showTeamInHeader={true}
      />,
      !trialExpired && <div key="2" id="executive" className='content-wrap'>
        <Helmet title="Value Streams" />        
        {!wallmode && (
          <Filter loading = {this.props.loading}
            threshold={this.state.threshold}
            changeThreshold={this.changeThreshold}
            dateRange={dateRange}
            changeDateRange={this.changeDateRange}
            controls={this.state.comparison}
            onApply={this.applyFilters}
            dashboards={filters.dashboards || []}
          />
        )}
        {this.state.comparison ? this.renderComparisonReport() : this.renderExecutiveReport()}
      </div>,
      trialExpired &&  
      <div className='main expired' key="3">
        <Header showTeam={true} buttons={<SubscribeEDAddOn></SubscribeEDAddOn>}/>
        <div className='centerContent'>
          <div>
            <h1 className='title'>Your trial has expired</h1></div>
          </div>
        </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err)),
    getFilters: id => dispatch(getFilters(id)),
    setFilters: (id, data) => dispatch(setFilters(id, data)),
    requestData: id => dispatch(requestData(id)),
    requestComparisonData: (page, id) => dispatch(requestComparisonData(page, id)),
    getComparisonPdf: (percentile, threshold, id) => dispatch(getComparisonPdf(percentile, threshold, id)),
    getPdf: (id) => dispatch(getPdf(id)),
    getCsv: (id) => dispatch(getCsv(id)),
    select: (itemId, viewId) => dispatch(selectStream(itemId, viewId)),
    remove: (id) => dispatch(deleteStream(id)),
    listAllStreams: () => dispatch(listAll()),
    selectStream: (item, viewId) => dispatch(selectStream(item, viewId)),
    saveSelectedStream: (id) => dispatch(saveSelected(id)),
    saveSelectedBreakdown: (id, chart, value) => dispatch(saveSelectedBreakdown(id, chart, value)),
    saveSelectedDateRange: (id, dateRange) => dispatch(saveSelectedDateRange(id, dateRange))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    wallmode: state.app.wallmode,
    selected: state.report.selectedStream,
    filters: state.report.filters,
    dateRange: state.report.dateRange,
    loading: state.report.isLoading,
    comparisons: state.report.comparisons,
    stats: state.report.stats,
    trends: state.report.trends,
    streams: state.report.streams,
    selectedStream: state.report.selectedStream,
    noStreams: state.report.noStreams,
    loaded: state.report.loaded,
    user: state.auth.user,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reports));
export { Reports };
